/* CARTRI - Barra flotante de compra en la ficha + resumen fijo del
   configurador en movil.

   Se mide con getBoundingClientRect en un listener de scroll con
   rAF en vez de IntersectionObserver: el observer no dispara de
   forma fiable en pestanas en segundo plano ni tras los
   re-render de Shopify, y aqui la precision importa mas que el
   ahorro de CPU. El intervalo de respaldo llama directo a
   repasar() porque rAF tampoco corre con la pestana oculta. */
(function () {
  'use strict';

  var MOVIL = '(max-width: 749px)';
  function esMovil() { return window.matchMedia(MOVIL).matches; }
  function esFicha() { return window.location.pathname.indexOf('/products/') !== -1; }
  function alto() { return window.innerHeight || document.documentElement.clientHeight || 0; }

  var tareas = [];
  var pedido = false;

  function repasar() {
    pedido = false;
    for (var i = 0; i < tareas.length; i++) {
      try { tareas[i](); } catch (e) { /* una tarea rota no tumba el resto */ }
    }
  }
  function pedir() {
    if (pedido) return;
    pedido = true;
    window.requestAnimationFrame(repasar);
  }

  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir, { passive: true });
  window.addEventListener('orientationchange', pedir);
  document.addEventListener('cart:refresh', pedir);
  setInterval(repasar, 700);

  /* =========================================================
     1. BARRA FLOTANTE DE COMPRA
     Se ensena cuando los botones reales de compra (anadir al
     carrito + pago rapido) salen de pantalla, y se retira en
     cuanto vuelven a verse.
     ========================================================= */
  function montarBuybar() {
    if (!esFicha()) return;
    if (document.querySelector('.liq-buybar')) return;

    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var zona = info.querySelector('.product-form__buttons');
    var submit = info.querySelector('.product-form__submit');
    if (!zona || !submit) return;

    var precio = info.querySelector('.price');
    var tituloEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var titulo = tituloEl ? tituloEl.textContent.trim() : '';
    var foto = document.querySelector('.product__media img, .product__media-item img');
    var src = foto ? (foto.currentSrc || foto.src || '') : '';

    var bar = document.createElement('div');
    bar.className = 'liq-buybar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Compra rapida');

    var html = '<div class="liq-buybar__inner">';
    if (src) {
      html += '<img class="liq-buybar__img" src="' + src + '" alt="" width="52" height="52" loading="lazy">';
    }
    html += '<div class="liq-buybar__txt">' +
      '<div class="liq-buybar__name">' + titulo + '</div>' +
      '<div class="liq-buybar__price" data-liq-bar-precio></div>' +
      '<div class="liq-buybar__save" data-liq-bar-ahorro hidden></div>' +
      '</div>' +
      '<button type="button" class="liq-buybar__btn" data-liq-bar-btn>Agregar al carrito</button>' +
      '</div>';
    bar.innerHTML = html;
    document.body.appendChild(bar);

    var precioEl = bar.querySelector('[data-liq-bar-precio]');
    var ahorroEl = bar.querySelector('[data-liq-bar-ahorro]');
    var btn = bar.querySelector('[data-liq-bar-btn]');

    function texto(el) { return el ? el.textContent.trim() : ''; }

    function pintar() {
      var venta = precio && precio.querySelector('.price__sale .price-item--sale');
      var antes = precio && precio.querySelector('.price__sale s.price-item--regular');
      var normal = precio && precio.querySelector('.price__regular .price-item--regular');
      var ahora = texto(venta) || texto(normal);
      var previo = texto(antes);

      precioEl.innerHTML = (ahora ? '<b>' + ahora + '</b>' : '') +
        (previo ? '<s>' + previo + '</s>' : '');

      var pill = info.querySelector('.liq-ahorro');
      if (pill && pill.textContent.trim()) {
        ahorroEl.hidden = false;
        ahorroEl.textContent = pill.textContent.trim();
      } else { ahorroEl.hidden = true; }

      var agotado = !!submit.disabled;
      btn.disabled = agotado;
      btn.textContent = agotado ? 'Agotado' : 'Agregar al carrito';
    }

    btn.addEventListener('click', function () {
      if (submit.disabled) return;
      submit.click();
    });

    function carritoAbierto() {
      var d = document.querySelector('cart-drawer');
      return !!(d && d.classList.contains('active'));
    }

    tareas.push(function () {
      var r = zona.getBoundingClientRect();
      var fuera = r.bottom < 0 || r.top > alto();
      bar.classList.toggle('is-on', fuera && !carritoAbierto());
    });

    /* El precio cambia al elegir variante */
    if (precio && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(pintar, 60);
      }).observe(precio, { childList: true, subtree: true, characterData: true });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(pintar).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    }

    pintar();
    repasar();
  }

  /* =========================================================
     2. RESUMEN FIJO DEL CONFIGURADOR EN MOVIL
     Mientras "Personaliza tu pack" ocupa la pantalla, el
     resumen baja a una barra fija y deja de comerse el alto.
     ========================================================= */
  function montarPackbar() {
    var raiz = document.querySelector('[data-liq-pack]');
    var pack = raiz ? (raiz.closest('.liq-pack') || raiz) : document.querySelector('.liq-pack');
    if (!pack || pack.hasAttribute('data-bar-listo')) return;
    pack.setAttribute('data-bar-listo', '1');

    tareas.push(function () {
      if (!esMovil()) { pack.classList.remove('is-bar'); return; }
      var r = pack.getBoundingClientRect();
      var h = alto();
      /* Con que la seccion ocupe el tercio central de la pantalla
         ya damos por hecho que el usuario esta montando el pack. */
      var dentro = r.top < h * 0.75 && r.bottom > h * 0.35;
      pack.classList.toggle('is-bar', dentro);
    });

    repasar();
  }

  /* =========================================================
      3. ALTURA DEL HEADER STICKY
      El resumen del configurador se ancla con top fijo y se
      metia bajo el header cuando este media mas de 8.5rem.
      Publicamos su alto real en --liq-header-h. Usamos
      offsetHeight porque ignora la animacion de
      entrada/salida del header y el valor es estable.
      ========================================================= */
  function montarHeaderVar() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    function medir() {
      var h = header.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty('--liq-header-h', h + 'px');
    }
    medir();
    window.addEventListener('resize', medir, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(medir).observe(header);
    }
  }

  function arrancar() {
    montarBuybar();
    montarPackbar();
    montarHeaderVar();
    repasar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else { arrancar(); }
  document.addEventListener('shopify:section:load', arrancar);
})();
